import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useMemo } from 'react';
import { markActionComplete } from 'user-context/onboarding';
import PortalIdParser from 'PortalIdParser';
import { useLocalStorage } from './useLocalStorage';
import { useObjectTypeId } from './useObjectTypeId';
import { useProperty } from './useProperty';
export const useTicketStatusChangeTracking = onChange => {
  const objectTypeId = useObjectTypeId();
  const property = useProperty();

  // Use useMemo to cache the localStorage key - only computed once per hook instance
  const ticketStatusActionKey = useMemo(() => {
    const portalId = PortalIdParser.get();
    return `hasCompletedTicketStatusAction-${portalId}`;
  }, []);
  const [hasCompletedTicketStatusAction, setHasCompletedTicketStatusAction] = useLocalStorage(ticketStatusActionKey, false);
  const onChangeWithTicketStatusTracking = useCallback(changes => {
    if (objectTypeId === TICKET_TYPE_ID && property.name === 'hs_pipeline_stage') {
      // Only call markActionComplete if we haven't already completed it successfully
      if (!hasCompletedTicketStatusAction) {
        markActionComplete('update-ticket-status').then(() => {
          // Mark as completed to prevent future calls
          setHasCompletedTicketStatusAction(true);
        }).catch(() => {
          // Don't mark as completed on failure - allow retries
        });
      }
    }
    onChange(changes);
  }, [onChange, objectTypeId, property.name, hasCompletedTicketStatusAction, setHasCompletedTicketStatusAction]);
  return onChangeWithTicketStatusTracking;
};